import React, { forwardRef, useEffect, useState, useImperativeHandle} from 'react'
import './captcha.style.scss'
export const Captcha = forwardRef((props, ref) => {  
  const [text, setText] = useState([])

  useImperativeHandle(
    ref,
    () => ({
      reset() {
        generateCaptcha()
      }
    })
    ,[]
  )
    
  const generateCaptcha = () => {
    let textArray = []
    let originTextArray = []
   
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
    for (var i = 0; i < 5; i++) {
        let char = possible.charAt(Math.floor(Math.random() * possible.length))
        textArray.push(
            `<text 
                font-family="Roboto" 
                font-size="30" 
                x="${25* i}" 
                y="${25}"
                fill="${"#" + ((1 << 24) * Math.random() | 0).toString(16)}"
                transform="rotate(${Math.random() * (5 - 0) + 0})"
            >${char}</text>`
          )
          originTextArray.push(
            char
        )
    }

    props.setCaptcha(originTextArray.join(''))
    setText(textArray)
   
  }

  useEffect(() => {
    generateCaptcha()
  }, [])

  return (
     
    <img
        className="captcha"
        
        src={
            'data:image/svg+xml;base64,' +
            btoa('<svg ' +
                'xmlns="http://www.w3.org/2000/svg" ' +
                'height="50" ' +
                'width="130">' +
                  text.join() +
                '</svg>')
        }
        alt="" />
);
})